import dispatchGoLogoUrl from "../../assets/apps/dispatchgo_app.svg";
import fieldGoLogoUrl from "../../assets/apps/fieldgo_app.svg";
import oilGoLogoUrl from "../../assets/apps/oilgo_app.svg";
import waterGoLogoUrl from "../../assets/apps/watergo_app.svg";

export type OtsMobileApp = {
  id: string;
  name: string;
  /** URL of the app's icon. */
  logo: string;
  ios: string;
  android: string;
};

/** OTS's mobile apps and their store listings -- one list for every web app that points people to them. */
export const otsMobileApps: readonly OtsMobileApp[] = [
  {
    id: "water-go",
    name: "WaterGo",
    logo: waterGoLogoUrl,
    ios: "https://apps.apple.com/us/app/watergo/id1257867861",
    android: "https://play.google.com/store/apps/details?id=com.wm.android"
  },
  {
    id: "oil-go",
    name: "OilGo",
    logo: oilGoLogoUrl,
    ios: "https://apps.apple.com/us/app/oilgo/id6737415081",
    android: "https://play.google.com/store/apps/details?id=com.wm.oilgo"
  },
  {
    id: "field-go",
    name: "FieldGo",
    logo: fieldGoLogoUrl,
    ios: "https://apps.apple.com/us/app/fieldgo/id1478785949",
    android: "https://play.google.com/store/apps/details?id=com.wm.fieldwork.android"
  },
  {
    id: "dispatch-go",
    name: "DispatchGo",
    logo: dispatchGoLogoUrl,
    ios: "https://apps.apple.com/us/app/dispatchgo/id1600523034",
    android: "https://play.google.com/store/apps/details?id=com.wm.dispatchgo"
  }
];
